import PropTypes from './PropTypes.js';
import describe from './describe.js';

export { describe, PropTypes };
export type { DSPropTypesSchema } from './types.js';
